import Header from './components/Header';
import Hero from './components/Hero';
import SectionIndex from './components/SectionIndex';
import SectionFeatures from './components/SectionFeatures';
import SectionContact from './components/SectionContact';
import SectionApp from './components/SectionApp';
import SectionRanking from './components/SectionRanking';
import SectionCarousel from './components/SectionCarousel';
import SectionAbout from './components/SectionAbout';
import SectionUpdates from './components/SectionUpdates';
import SectionTopics from './components/SectionTopics';
import SectionComments from './components/SectionComments';
import SectionMedia from './components/SectionMedia';
import SectionCards from './components/SectionCards';
import SectionFaq from './components/SectionFaq';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50">
      <Header />
      <main>
        <Hero />
        <SectionIndex />
        <SectionFeatures />
        <SectionContact />
        <SectionApp />
        <SectionRanking />
        <SectionCarousel />
        <SectionAbout />
        <SectionUpdates />
        <SectionTopics />
        <SectionComments />
        <SectionMedia />
        <SectionCards />
        <SectionFaq />
      </main>
      <Footer />
    </div>
  );
}